import { commonAPI } from '@redux/api/common.api'
import { URLS } from '@constants'
import { MobileForm } from '@mobileTypes'

type GETMobileFormsParams = {
  searchPattern?: string
  sort?: string
}

export const mobileFormApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllMobileForms: build.query<MobileForm[], GETMobileFormsParams | void>({
      query: params => ({
        url: URLS.MOBILE_CFG + '/form',
        params: {
          searchPattern: params?.searchPattern,
          sort: params?.sort,
        },
      }),
      providesTags: ['AllMobileForms'],
    }),

    fetchMobileFormById: build.query<MobileForm, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/form/id/${id}`,
      }),
      providesTags: ['SingleMobileForm'],
    }),

    createMobileForm: build.mutation<MobileForm, Omit<MobileForm, 'id' | 'createdAt' | 'updatedAt'>>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/form',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileForms'],
    }),

    updateMobileForm: build.mutation<MobileForm, MobileForm>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/form',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileForms', 'SingleMobileForm'],
    }),

    deleteMobileForm: build.mutation<void, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/form/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllMobileForms'],
    }),

    copyMobileForm: build.mutation<MobileForm, { id: string; name: string; internalId: string }>({
      query: body => ({
        url: URLS.MOBILE_CFG + '/form/copy',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AllMobileForms'],
    }),
  }),
})

export const {
  useFetchAllMobileFormsQuery,
  useFetchMobileFormByIdQuery,
  useCreateMobileFormMutation,
  useUpdateMobileFormMutation,
  useDeleteMobileFormMutation,
  useCopyMobileFormMutation,
} = mobileFormApi
